// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3X6ej","reset":"styles_reset__2rQ3K","form":"styles_form__3_9-Z","submit":"styles_submit__3tWAg","logocontainer":"styles_logocontainer__AJwnV"};